import { Layouts } from '~/shared';
import { AbstractGuiService } from './AbstractGuiService';
import { IGuiService } from './guiServiceTypes';

export class GuiServiceStub extends AbstractGuiService implements IGuiService {
	constructor() {
		super();

		this.minimapInfo.next({ x: 29, y: 20, width: 240, height: 180 });

		window.onpopstate = () => this.update();
		this.update();
	}

	private update() {
		const queryLayouts = new URLSearchParams(window.location.search).get(
			'layouts',
		);
		const layouts = (queryLayouts?.split(',') ?? [])
			.map((name) => {
				if (!Object.values(Layouts).includes(name as Layouts)) {
					console.error(`Cannot find layout with name "${name}"`);
					return false;
				}
				return name;
			})
			.filter(Boolean) as Layouts[];

		this.getVisibleLayouts()
			.getValue()
			.forEach((layout) => {
				if (!layouts.includes(layout)) {
					this.setLayoutVisibleState(layout, false);
				}
			});

		layouts.forEach((layout) => {
			this.setLayoutVisibleState(layout, true);
		});
	}

	public async setGameHudVisible(isVisible: boolean): Promise<void> {
		console.log('gui:setGameHudVisible', { isVisible });
	}

	public async setCursorVisible(name: string, visible: boolean): Promise<void> {
		console.log('gui:setCursorVisible', { name, visible });
	}

	public async shouldDeclineInvite(): Promise<boolean> {
		return false;
	}
}
